import * as angular from "angular";
import { CollectionPurposeService } from "../services/collection-purpose.service";

export class CollectionPurposeDataProvider {
    private $q: any;
    private service: CollectionPurposeService;
    private officer: object | null = null;

    constructor($q: any, CollectionPurposeService: CollectionPurposeService) {
        this.$q = $q;
        this.service = CollectionPurposeService;
    }

    getOfficer(): Promise<any> {
        const deferred = this.$q.defer();
        if (this.officer === null) {
            this.service.protection().then(
                (response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.officer = json.data;
                        deferred.resolve(this.officer);
                    } else {
                        deferred.reject(json);
                    }
                },
                (error: object) => {
                    this.officer = null;
                    deferred.reject(error);
                }
            );
        } else {
            deferred.resolve(this.officer);
        }
        return deferred.promise;
    }

    points(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.points().then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    all(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.all().then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    update(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.update(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    create(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.create(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    clearAll(): void {
        this.officer = null;
    }

    createOfficer(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.createOfficer(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.officer = json.data;
                    deferred.resolve(this.officer);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => {
                this.officer = [];
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }

    updateOfficer(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.updateOfficer(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.officer = json.data;
                    deferred.resolve(this.officer);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => {
                this.officer = [];
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }

    createPurpose(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.createPurpose(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => {
                this.officer = [];
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("CollectionPurposeDataProvider", CollectionPurposeDataProvider);
